<template>
    <div class="search-input">
        <IconSearch class="icon search" />
        <input v-model.trim="searchText" :placeholder="placeholder"
               class="search"
               type="text"
               @input="onInput()"
               @keyup.enter="emitSearch(searchText)"
        />
        <IconClose v-if="!emptyQuery"
                   class="icon clear"
                   @click="onClear()"
        />
    </div>
</template>

<script>
import Timer from '@dsee/util/timer.js';

export default {
    props: {
        searchDelay: {
            type: Number,
            default: 300,
        },
        placeholder: {
            type: String,
        },
        lazy: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        emptyQuery() {
            return !this.searchText;
        },
    },
    data() {
        return {
            searchText: '',
        };
    },
    methods: {
        onClear() {
            this.searchText = '';
            this.emitSearch('');
        },
        onInput() {
            if (!this.lazy)
                return;

            this.lazySearch();
        },
        emitSearch(searchText) {
            this.$emit('search', searchText);
        },
        lazySearch() {
            this.$options.searchTimer.setTimeout(
                () => this.emitSearch(this.searchText),
                this.searchDelay,
            );
        },
    },
    created() {
        this.$options.searchTimer = new Timer();
    },
};
</script>

<style lang="scss" scoped>
.search-input {
    position: relative;
    width: 100%;

    .search:not(.icon) {
        padding: 8px 36px;
    }

    .icon {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);

        path {
            fill: rgba(16, 24, 40, 0.5);
        }

        &.search {
            left: 12px;
        }

        &.clear {
            right: 12px;
            cursor: pointer;
        }
    }
}
</style>
